import axios from 'axios'

export default {
    namespaced: true,
    data: () => ({
        appApiUrl: process.env.VUE_APP_API_URL,
    }),
    state: {
        topics: [],
        selectAll: false
    },
    getters: {            
        reportTopics: (state, getters) => {                        
            return state.topics;
        },
        selectAllTopics: (state, getters) => {
            return state.selectAll;
        },
    },
    mutations: {
        SET_TOPICS(state, topics) {
            var topicsByGroup = [];
            if (topics && topics.length > 0) {
                topics.forEach(group => {
                    if (topicsByGroup.length > 0) {
                        var existingGroup = topicsByGroup.find(g => g.TopicGroupName == group.TopicGroupName);
                        if (existingGroup) {
                            existingGroup.Topics.push({ TopicName: group.TopicName, TopicId: group.TopicID, IsSelected: false });
                        } else {
                            topicsByGroup.push({ TopicGroupName: group.TopicGroupName, Tooltip: group.TopicTooltip, Topics: [{ TopicName: group.TopicName, TopicId: group.TopicID, IsSelected: false }] });
                        }
                    } else {
                        topicsByGroup.push({ TopicGroupName: group.TopicGroupName, Tooltip: group.TopicTooltip, Topics: [{ TopicName: group.TopicName, TopicId: group.TopicID , IsSelected: false }] });
                    }
                });                
            }
            state.topics = topicsByGroup;
            state.selectAll = false;
        }
    },
    actions: {         
        setSelectAllToggle({ state }, val) {
            state.selectAll = val;
        },
        async getTopics({ state, dispatch, getters, commit }) {
            return await new Promise((resolve) => {
                axios({
                    method: 'get',
                    url: process.env.VUE_APP_API_URL + '/Values/topics',
                    data: {}
                }).then(async function (response) {
                    commit('SET_TOPICS', response.data)
                    return resolve(true);
                }).catch(function (error) {
                    console.log(error);
                    return resolve(null);
                });
            });
        },
        async generateReport({ state }, val) {
            return await new Promise((resolve) => {               
                axios({
                    method: 'post',
                    url: process.env.VUE_APP_API_URL + '/Report/pdf',
                    data: val,
                    responseType: 'blob'
                }).then(async function (response) {                  
                    let fileName = 'TimberX.pdf';
                    if (response && response.headers) {
                        try {
                            fileName = JSON.parse(response.headers['content-disposition'].split("filename=")[1]);
                        }  catch (e) {}                        
                    } 
                    return resolve({ fileName: fileName, data: response.data });
                }).catch(function (error) {
                    console.log(error);
                    return resolve(null);
                });
            });
        }        
    }
}
